import { render, staticRenderFns } from "./HeaderAggregate.vue?vue&type=template&id=5bbc3b24&scoped=true"
import script from "./HeaderAggregate.vue?vue&type=script&lang=js"
export * from "./HeaderAggregate.vue?vue&type=script&lang=js"
import style0 from "./HeaderAggregate.vue?vue&type=style&index=0&id=5bbc3b24&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bbc3b24",
  null
  
)

export default component.exports